<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label d-flex flex-column">
        <span>{{ getTitle() | translate }}</span>
        <span *ngIf="data.useGlobal" class="font-size-base font-weight-normal text-dark-50 mt-1">{{
          'FORMS_TEMPLATES_MODULE.FORM.CREATE_FROM_GLOBAL_SUBTITLE' | translate
        }}</span>
      </h3>
    </div>
  </div>
  <div
    style="max-height: 70vh !important"
    class="card-body scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <form [formGroup]="form" class="form form-group mb-0">
      <div *ngIf="mapped" class="alert alert-custom alert-light-warning fade show px-6 py-2 mb-10">
        <div class="alert-icon">
          <i style="font-size: 1.6rem !important" class="flaticon-warning"></i>
        </div>
        <div class="alert-text">Mapped! By updating the form, it is required to reset mapping.</div>
        <div class="alert-close">
          <button type="button" class="close" data-dismiss="alert">
            <i class="ki ki-close"></i>
          </button>
        </div>
      </div>
      <div [hidden]="!data.useGlobal" class="w-100 mb-4">
        <kt-general-autocomplete
          #globalFormAutocomplete
          [label]="'Global Form'"
          [dataPath]="'data'"
          [loadItemsFunction]="getGlobalFormAutocomplete"
          [optionFormatter]="formatFormOption"
          [valueFormatter]="formatFormOption"
          [change]="handleFormChange.bind(this)"
          [required]="data.useGlobal"
        ></kt-general-autocomplete>
      </div>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.NAME' | translate }}</mat-label>
        <input matInput type="text" formControlName="name" required maxlength="100" />
        <mat-error *ngIf="isInvalid('name')">{{
          getErrorMessage('FORMS_TEMPLATES_MODULE.FORM.NAME' | translate)
        }}</mat-error>
      </mat-form-field>
      <div [hidden]="data.isSuperAdmin">
        <div class="w-100 mb-4">
          <kt-general-autocomplete
            #teamAutocomplete
            [label]="'FORMS_TEMPLATES_MODULE.FORM.TEAMS_CATEGORIES' | translate"
            [chipList]="true"
            [dataPath]="'data'"
            [control]="teamAutocomplete"
            [objects]="teamAutocomplete.value"
            [loadItemsFunction]="getTeamAutocomplete"
            [optionFormatter]="formatTeamOption"
            [valueFormatter]="formatTeamOption"
            [formatNewObjectFn]="formatNewTeam"
            [required]="!data.isSuperAdmin"
            [readOnly]="(data.useGlobal && !globalFormAutocomplete?.value) || data.viewMode"
          ></kt-general-autocomplete>
        </div>
        <mat-form-field appearance="fill" class="w-100 mb-4">
          <mat-label>{{ 'FORMS_TEMPLATES_MODULE.FORM.SYSTEM' | translate }}</mat-label>
          <mat-select
            formControlName="system"
            [required]="!data.isSuperAdmin"
            [disabled]="!!data.form?.system"
          >
            <mat-option *ngFor="let system of formSystems" [value]="system">{{
              stringUtils.formatEnumString(system)
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="isInvalid('system')">{{
            getErrorMessage('FORMS_TEMPLATES_MODULE.FORM.SYSTEM' | translate)
          }}</mat-error>
        </mat-form-field>
        <div *ngIf="!data.viewMode" class="w-100 mb-4">
          <kt-general-autocomplete
            [label]="'Program'"
            [dataPath]="'data'"
            [hint]="'Compliance Program'"
            [control]="form.get('program')"
            [change]="handleProgramChange.bind(this)"
            [loadItemsFunction]="getProgramAutocomplete"
            [optionFormatter]="formatProgramOption"
            [valueFormatter]="formatProgramOption"
            [readOnly]="data.useGlobal && !globalFormAutocomplete?.value"
          ></kt-general-autocomplete>
        </div>
        <div class="w-100 mb-4">
          <kt-general-autocomplete
            [label]="'Standards'"
            [chipList]="true"
            [dataPath]="'data'"
            [hint]="'Compliance Standards'"
            [control]="form.get('standards')"
            [objects]="form.get('standards').value"
            [change]="handleStandardChange.bind(this)"
            [loadItemsFunction]="getStandardAutocomplete"
            [optionFormatter]="formatStandardOption"
            [valueFormatter]="formatStandardOption"
            [formatNewObjectFn]="formatNewStandard"
            [readOnly]="data.viewMode || !form.get('program').value"
          ></kt-general-autocomplete>
        </div>
      </div>
      <button
        type="button"
        [disabled]="data.useGlobal && !globalFormAutocomplete?.value"
        class="btn btn-primary d-block w-100"
        (click)="manageSchema($event)"
      >
        {{
          (data.viewMode ? 'TABLE.VIEW' : form.get('schema').value ? 'TABLE.UPDATE' : 'TABLE.ADD')
            | translate
        }}
        {{ 'FORMS_TEMPLATES_MODULE.FORM.SCHEMA.TITLE' | translate }}
      </button>
      <mat-form-field appearance="fill" class="btn-form-field w-100">
        <input matInput hidden type="text" formControlName="schema" required />
        <mat-error *ngIf="isInvalid('schema')">{{
          getErrorMessage('FORMS_TEMPLATES_MODULE.FORM.SCHEMA.TITLE' | translate)
        }}</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      *ngIf="!data.viewMode"
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
